import { firestore } from '../utils/firebase'
import { userConverter } from '../data-contracts/User'

// ------------------------------------
// Constants
// ------------------------------------

const CREATE_USER = 'CREATE_USER'
const FETCH_USER = 'FETCH_USER'
const FETCH_USERS = 'FETCH_USERS'
const UPDATE_USER = 'UPDATE_USER'

const initialState = {
  users: [],
}

const userRef = firestore.collection('users')

// ------------------------------------
// Actions
// ------------------------------------

export const createUser = user => dispatch =>
  new Promise(async (resolve, reject) => {
    try {
      userRef
        .doc(user.id)
        .withConverter(userConverter)
        .set(user)
        .then(() => {
          resolve(user)
          dispatch({
            type: CREATE_USER,
            user,
          })
        })
    } catch (err) {
      reject(err)
    }
  })

export const updateUser = user => dispatch => {
  const docRef = userRef.doc(user.id)

  return new Promise(async (resolve, reject) => {
    try {
      docRef.update({ ...user }).then(() => {
        resolve()
        dispatch({
          type: UPDATE_USER,
        })
      })
    } catch (err) {
      reject(err)
    }
  })
}

export const fetchUser = user => dispatch =>
  new Promise(async (resolve, reject) => {
    try {
      userRef.doc(user).onSnapshot(doc => {
        if (doc.exists) {
          dispatch({
            type: FETCH_USER,
            payload: doc.data(),
          })
          resolve(doc.data())
        } else {
          reject(new Error('No such document exists'))
        }
      })
    } catch (err) {
      reject(err)
    }
  })

export const fetchUsers = () => dispatch => {
  const users = []
  userRef.get().then(querySnapshot => {
    querySnapshot.forEach(doc => {
      // doc.data() is never undefined for query doc snapshots
      users.push(doc.data())
    })

    dispatch({
      type: FETCH_USERS,
      payload: users,
    })
  })
}

export const actions = {
  createUser,
  fetchUser,
  fetchUsers,
  updateUser,
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREATE_USER]: (state, { user }) => ({
    ...state,
    user,
  }),
}

// ------------------------------------
// Reducer
// ------------------------------------

export default function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}
